import { useTranslations } from 'next-intl'
import { useEffectOnce } from 'react-use'
import { Mail } from 'lucide-react'

import {
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { GoogleLoginButton2 } from '@/components/login'
import sendToBothAnalytics from '@/lib/mixpanel/sendToBothAnalytics'
import { MIXPANEL_CLIENT_EVENT_NAMES } from '@/lib/mixpanel/constant'

export default function LoginModal({ redirectUrl }: { redirectUrl: string }) {
  const t = useTranslations('modals.login')

  useEffectOnce(() => {
    sendToBothAnalytics(MIXPANEL_CLIENT_EVENT_NAMES.VIEW_LOGIN_MODAL, {
      redirectUrl,
    })
  })

  const handleEmailLogin = () => {
    window.location.href = `/login?redirectUrl=${encodeURIComponent(redirectUrl)}`
  }

  return (
    <DialogContent
      className="w-[95%] max-w-[400px] p-0 rounded-[20px] overflow-hidden border border-[#3B3B3B]"
      style={{
        background:
          'linear-gradient(104deg, #222 1.87%, #2B2B2B 56.52%, #010101 111.18%)',
        boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
      }}
    >
      <div className="px-6 py-6">
        <DialogHeader className="mb-6">
          <DialogTitle className="text-xl font-semibold text-white text-left">
            {t('title')}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-3">
          <GoogleLoginButton2 redirectUrl={redirectUrl} />

          <button
            type="button"
            onClick={handleEmailLogin}
            className="w-full flex items-center justify-center gap-2 rounded-lg bg-[#3A3A3A] hover:bg-[#4A4A4A] px-4 py-3 font-semibold text-white transition-colors focus:outline-none focus:ring-2 focus:ring-white/20"
          >
            <Mail className="w-4 h-4" aria-hidden="true" />
            {t('continue_with_email')}
          </button>
        </div>
      </div>
    </DialogContent>
  )
}
